module.exports = __webpack_public_path__ + "static/media/icon_email.15f29c0c.svg";